import { useTranslation } from "react-i18next";
import { NotificationItem } from "@/stores/notifications/notificationStore";
import { notificationsActionList } from "@/domains/notifications/helpers/notificationsActionList";
import NotificationsActionBody from "@/domains/notifications/components/NotificationsActionBody";

type Props = {
  item: NotificationItem;
};

export default function NotificationsActionContainer({ item }: Props) {
  const action = notificationsActionList[item.data.type];
  const { t } = useTranslation("notifications");

  if (!action) return null;

  return (
    <NotificationsActionBody
      color={action.color}
      text={t(`event.${item.data.type}`, { color: action.color })}
      icon={action?.icon}
    />
  );
}
